/**
 * main 내 tag 형식으로 페이지 히스토리 관리를 위한 기능의 Store
 */
const MAX_TAB_COUNT = 20
const VIEW_TYPES = ['ALL', 'FROM_TWO']

const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    // viewType으로 tag-view Control 한다.
    // 'ALL' 일 경우, 특별한 경우가 아니면 통제없이 모두 보여 주는 것
    // 'FROM_TWO' 일 경우 두 개부터 출력된다. 대시 보드 같은 화면은 1개만 있을 경우 출력하지 않을 경우에 사용된다.
    viewType: 'ALL'
  },
  mutations: {
    ADD_VISITED_VIEW: (state, view) => {
      if (state.visitedViews.some(v => v.name === view.name)) return
      state.visitedViews.push(
        Object.assign({}, view, {
          title: view.meta.title || 'no-name'
        })
      )
    },
    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViews.includes(view.name)) return
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },

    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },
    DEL_CACHED_VIEW: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },

    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break
        }
      }
    },
    DEL_OTHERS_CACHED_VIEWS: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, index + 1)
          break
        }
      }
    },

    DEL_ALL_VISITED_VIEWS: state => {
      state.visitedViews = []
    },
    DEL_ALL_CACHED_VIEWS: state => {
      state.cachedViews = []
    },

    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViews) {
        if (v.path === view.path) {
          v = Object.assign(v, view)
          break
        }
      }
    },
    CHANGE_TAG_VIEW_TYPE: (state, viewType) => {
      state.viewType = viewType
    }
  },
  actions: {
    AddView({ dispatch }, view) {
      dispatch('AddVisitedView', view)
      dispatch('AddCachedView', view)
    },
    AddVisitedView({ commit, dispatch, state }, view) {
      commit('ADD_VISITED_VIEW', view)
      if (state.visitedViews.length > MAX_TAB_COUNT) {
        // MAX_TAB_COUNT에 정해진 값을 넘어 서면 최초 태그를 삭제한다.
        dispatch('DelView', state.visitedViews[0])
      }
    },
    AddCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },

    DelView({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('DelVisitedView', view)
        dispatch('DelCachedView', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    DelVisitedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
    DelCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },

    DelOthersViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('DelOthersVisitedViews', view)
        dispatch('DelOthersCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    DelOthersVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    DelOthersCachedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_CACHED_VIEWS', view)
        resolve([...state.cachedViews])
      })
    },

    DelAllViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('DelAllVisitedViews', view)
        dispatch('DelAllCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    DelAllVisitedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_VISITED_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    DelAllCachedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_CACHED_VIEWS')
        resolve([...state.cachedViews])
      })
    },

    UpdateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    },
    ChangeTagViewType({ commit }, viewType) {
      if (!VIEW_TYPES.includes(viewType)) return
      commit('CHANGE_TAG_VIEW_TYPE', viewType)
    }
  }
}

export default tagsView
